import type { Moment } from "moment";

// eslint-disable-next-line import/prefer-default-export
export const formatMomentAsDateForApi = (moment: Moment): string => moment.format("YYYY-MM-DD");
